import { MOption } from "../../shared/shared.model";

export interface Category {
  uuid: string;
  imagePath: string;
  category1Cuuid: string;
}

export enum ActionType {
  edit,
  delete,
}
export interface CategoryUI extends Category, MOption {
  key?: number;
  index?: number;
  actions?: Action[];
  file?: any;
  categoryDto?: {
    category1Cuuid: string;
  };
}

export interface Action {
  icon: string;
  text: string;
  type: ActionType;
}
